import { Component, OnInit, Input } from '@angular/core';
import { TestToplistComponent } from '../test-toplist/test-toplist.component';
import { TestTopList, TestTopListItem } from 'src/app/shared/models/test.model';
import { MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';

import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'app-test-top-list-card',
    templateUrl: './test-top-list-card.component.html',
    styleUrls: ['./test-top-list-card.component.css'],
    imports: [MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardContent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatCardActions]
})





export class TestTopListCardComponent implements OnInit {

  @Input() TopList: TestTopList;

  displayedColumns: string[] = ['Position','Medal', 'PlayerLastName','PerformedDate', 'Result'];
  dataSource: TestTopListItem[];

  
  constructor() { }

  ngOnInit() {    
    this.dataSource = this.TopList.Items;
  }

}
